<template>
  <stacked-card>
    <notification-card
      :title="rule.model.comments"
      :iso-timestamp="rule.model.addedAt"
      icon="atom"
      icon-class="has-text-danger fa-x5">
      Matches on {{ first }} +{{ otherCount.toLocaleString() }} others
    </notification-card>
    
    <!-- actions -->
    <template #buttons>
      <a @click="$emit('delete')" class="button is-danger stacked-button">
        <font-awesome-icon icon="trash-can"/>
      </a>
    </template>
    <!-- eo:actions -->

  </stacked-card>
</template>

<script>
export default {
  emits: ['delete'],
  props: {
    rule: Object
  },
  computed: {
    first () { return this.rule.model.metaData[0].property },
    otherCount () { return this.rule.model.metaData.length - 1 },
  }
}
</script>